import { createReducer, updateState } from '@angular-architects/ngrx-toolkit';
import {
    CLIENT_DETAIL_INITIAL_STATE,
    CLIENT_INFO_INITIAL_STATE,
    CompanyStoreState,
    GENERATE_QR_DETAILS_INITIAL_STATE,
    QR_DETAILS_INITIAL_STATE,
} from './company.state';
import { companyActions as actions } from './company.action';

export const companyReducer = createReducer<CompanyStoreState, typeof actions>(
    (actions, on) => {
        on(actions.setClientInfo, (state, { value }) => {
            updateState(state, 'set client info', { clientInfo: value });
        });
        on(actions.setId, (state, { value }) => {
            updateState(state, 'setId', { id: value });
        });
        on(actions.setQrDetails, (state, { value }) => {
            updateState(state, 'setQrDetails', { qrDetails: value });
        });
        on(actions.setGenerateQRDetails, (state, { value }) => {
            updateState(state, 'setGenerateQRDetails', { generateQRDetails: value });
        });
        on(actions.setClientDetailInfo, (state, { value }) => {
            updateState(state, 'setClientDetailInfo', { clientDetailInfo: value });
        });
        on(actions.getClientDetailInfo, (state, { id }) => {
            updateState(state, 'getClientDetailInfo', { id });
        });
        on(actions.getVendorDetailInfo, (state, { id }) => {
            updateState(state, 'getVendorDetailInfo', { id });
        });
        on(actions.getClientCompanyLogo, (state, { id }) => {
            updateState(state, 'getClientCompanyLogo', { id });
        });
        on(actions.resetQrDetails, (state) => {
            updateState(state, 'resetQrDetails', { qrDetails: QR_DETAILS_INITIAL_STATE });
        });
        on(actions.resetGenerateQRDetails, (state) => {
            updateState(state, 'resetGenerateQRDetails', {
                generateQRDetails: GENERATE_QR_DETAILS_INITIAL_STATE,
            });
        });
        on(actions.resetClientDetailInfo, (state) => {
            updateState(state, 'resetClientDetailInfo', {
                clientDetailInfo: CLIENT_DETAIL_INITIAL_STATE,
            });
        });
        on(actions.resetClientInfo, (state) => {
            updateState(state, 'resetClientInfo', {
                clientInfo: CLIENT_INFO_INITIAL_STATE,
            });
        });
        on(
            actions.resetAll,
            (state, { clientInfo, qrDetails, generateQRDetails, id, isBusy }) => {
                updateState(state, 'reset All company store', {
                    clientInfo,
                    qrDetails,
                    generateQRDetails,
                    id,
                    isBusy,
                });
            },
        );
        on(actions.setIsBusy, (state, { value }) => {
            updateState(state, 'set isBusy', { isBusy: value });
        });
        on(actions.setClientLogo, (state, { value }) => {
            updateState(state, 'set client logo', { clientLogo: value });
        });
    },
);
